export default __webpack_public_path__ + "static/media/smartphone.18df0f9b.svg";